import UserAvatarCell from './UserAvatarCell';

export default UserAvatarCell;
